//
import React, { ReactElement } from 'react';
import { StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import colors from '../../colors';
import { SIDE_PADDING, TOP_PADDING, TXT_GG, TXT_M } from '../../constants';

type Props = {
  icon: ReactElement;
  onPress: () => void;
  backgroundColor?: string;
  style?: StyleProp<ViewStyle>;
  size?: number;
};

const IconButton: React.FC<Props> = (props) => {
  const { icon, backgroundColor, onPress, size } = props;

  return (
    <TouchableOpacity
      style={{
        height: size ?? 30,
        width: size ?? 30,
        backgroundColor: backgroundColor ? backgroundColor : colors.primary,
        borderRadius: 7,
        justifyContent: 'center',
        alignItems: 'center'
      }}
      onPress={onPress}
    >
      {icon}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    paddingTop: TOP_PADDING
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  form: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  imagem: {
    width: '100%',
    height: 300,
    resizeMode: 'contain',
    borderRadius: 7
  },
  titulo: {
    fontSize: TXT_GG,
    fontWeight: '700',
    marginBottom: 20
    // color: colors.darkGrey
  },
  descricao: {
    fontSize: TXT_M
  }
});

export default IconButton;
